import { TreeCreateData } from './types'
import { Box, Button } from '@mui/material'
import { goToTree } from '../tree/TreeActions'

export function ScopeSequenceTreeCreateResponse({
  data,
}: {
  data: TreeCreateData
}) {
  const { curriculum_id, tree_id: treeId, version_id: versionId } = data
  return (
    <Box>
      <Box>{`Curriculum Id: ${curriculum_id}`}</Box>
      <Box>{`Tree Id: ${treeId}:${versionId}`}</Box>
      <Box>
        <Button onClick={() => goToTree({ treeId, versionId })}>Open</Button>
      </Box>
    </Box>
  )
}
